import * as React from 'react';

export const ResponsiveSizeContext = React.createContext({
  height: 0,
  width: 0
});